<template>
  <router-view class="h-full background" />

  <!-- Notificación de nueva versión -->
  <div v-if="showUpdateNotification"
    class="fixed bottom-4 right-4 bg-blue-500 text-white px-6 py-4 rounded-lg shadow-lg z-50 flex items-center gap-4">
    <div>
      <p class="font-bold">Nueva versión disponible</p>
      <p class="text-sm">Se recomienda actualizar para obtener las últimas mejoras</p>
    </div>
    <button @click="reloadPage" class="bg-white text-blue-500 px-4 py-2 rounded hover:bg-blue-50 font-semibold">
      Actualizar
    </button>
    <button @click="dismissUpdate" class="text-white hover:text-blue-200">
      ✕
    </button>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data() {
    return {
      currentVersion: null,
      showUpdateNotification: false,
      versionCheckInterval: null
    }
  },
  mounted() {
    // Cargar versión actual del build
    this.loadCurrentVersion();

    // Verificar nueva versión cada 5 minutos
    this.versionCheckInterval = setInterval(() => {
      this.checkForUpdates();
    }, 5 * 60 * 1000); // 5 minutos
  },
  beforeUnmount() {
    if (this.versionCheckInterval) {
      clearInterval(this.versionCheckInterval);
    }
  },
  methods: {
    async loadCurrentVersion() {
      try {
        const timestamp = new Date().getTime();
        const response = await fetch(`/version.json?t=${timestamp}`, {
          cache: 'no-store'
        });

        if (response.ok) {
          const data = await response.json();
          this.currentVersion = data.version;

          //console.log(`%c🚀 Odihnx Build ${this.currentVersion}`,
          //  'background: #0079FF; color: white; padding: 4px 8px; border-radius: 3px; font-weight: bold;'
          //);
          //console.log(`   Fecha: ${data.buildDate}`);

          // Iniciar verificación después de cargar la versión actual
          setTimeout(() => this.checkForUpdates(), 1000);
        }
      } catch (error) {
        console.debug('No se pudo cargar version.json:', error.message);
      }
    },
    async checkForUpdates() {
      if (!this.currentVersion) return;

      try {
        const timestamp = new Date().getTime();
        const response = await fetch(`/version.json?t=${timestamp}`, {
          cache: 'no-store',
          headers: {
            'Cache-Control': 'no-cache'
          }
        });

        if (response.ok) {
          const data = await response.json();
          const latestVersion = data.version;

          // Comparar timestamps: si el nuevo es mayor, hay actualización
          if (parseInt(latestVersion) > parseInt(this.currentVersion)) {
            console.log(`%c📦 Nueva versión disponible`,
              'background: #42b983; color: white; padding: 4px 8px; border-radius: 3px;'
            );
            console.log(`   Actual: ${this.currentVersion}`);
            console.log(`   Nueva: ${latestVersion}`);
            this.showUpdateNotification = true;
          }
        }
      } catch (error) {
        console.debug('Version check failed:', error.message);
      }
    },
    reloadPage() {
      // Limpiar cache y recargar
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => caches.delete(name));
        });
      }
      window.location.reload(true);
    },
    dismissUpdate() {
      this.showUpdateNotification = false;
    }
  }
}
</script>

<style>
.background {
  background-color: #FFFFFF;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='721' height='721' viewBox='0 0 800 800'%3E%3Cg fill='none' stroke='%230079FF61' stroke-width='2'%3E%3Cpath d='M769 229L1037 260.9M927 880L731 737 520 660 309 538 40 599 295 764 126.5 879.5 40 599-197 493 102 382-31 229 126.5 79.5-69-63'/%3E%3Cpath d='M-31 229L237 261 390 382 603 493 308.5 537.5 101.5 381.5M370 905L295 764'/%3E%3Cpath d='M520 660L578 842 731 737 840 599 603 493 520 660 295 764 309 538 390 382 539 269 769 229 577.5 41.5 370 105 295 -36 126.5 79.5 237 261 102 382 40 599 -69 737 127 880'/%3E%3Cpath d='M520-140L578.5 42.5 731-63M603 493L539 269 237 261 370 105M902 382L539 269M390 382L102 382'/%3E%3Cpath d='M-222 42L126.5 79.5 370 105 539 269 577.5 41.5 927 80 769 229 902 382 603 493 731 737M295-36L577.5 41.5M578 842L295 764M40-201L127 80M102 382L-261 269'/%3E%3C/g%3E%3Cg fill='%230079FF61'%3E%3Ccircle cx='769' cy='229' r='5'/%3E%3Ccircle cx='539' cy='269' r='5'/%3E%3Ccircle cx='603' cy='493' r='5'/%3E%3Ccircle cx='731' cy='737' r='5'/%3E%3Ccircle cx='520' cy='660' r='5'/%3E%3Ccircle cx='309' cy='538' r='5'/%3E%3Ccircle cx='295' cy='764' r='5'/%3E%3Ccircle cx='40' cy='599' r='5'/%3E%3Ccircle cx='102' cy='382' r='5'/%3E%3Ccircle cx='127' cy='80' r='5'/%3E%3Ccircle cx='370' cy='105' r='5'/%3E%3Ccircle cx='578' cy='42' r='5'/%3E%3Ccircle cx='237' cy='261' r='5'/%3E%3Ccircle cx='390' cy='382' r='5'/%3E%3C/g%3E%3C/svg%3E");
}
</style>
